import { IAttachment, IPageResolve, IResolve } from "./communal";
/**
 * 部门教程请求参数
 */
export interface IDeptTutorialRequest {
  /**
   * 搜索关键字
   */
  keyword?: string;
  /**
   * 页码
   */
  page?: number;
  /**
   * 分页大小
   */
  per_page?: number;
  /**
   * 教程状态，1 上架中，2 已下架
   */
  status?: string;
  /**
   * 观看状态，0 未观看，1 已观看
   */
  watching_status?: string;
  /**
   * ea
   */
  ea?: string;
}
/**
 * 部门教程
 */
export interface IDeptTutorial {
  /**
   * 区块哈希
   */
  block_hash: string;
  /**
   * 区块高度
   */
  block_height: number;
  /**
   * 教程封面，注：文档类型教程没有封面，需要前端默认一张图片
   */
  cover: string;
  /**
   * 创建时间
   */
  created_at: string;
  /**
   * 创建人，发布者
   */
  created_by: string;
  /**
   * 教程描述
   */
  description: string;
  /**
   * 结束时间，上架时间-结束
   */
  end_time: string;
  /**
   * 教程ID
   */
  id: string;
  /**
   * 教程编号
   */
  serial_number: string;
  /**
   * 开始时间，上架时间-开始
   */
  start_time: string;
  /**
   * 教程状态，1 上架中，2 已下架
   */
  status: number;
  /**
   * 状态名称
   */
  status_name: string;
  /**
   * 观看状态
   */
  watching_status: number;
  /**
   * 观看状态名称
   */
  watching_status_name: number;
  /**
   * 教程标题
   */
  title: string;
  /**
   * 教程类型，1 视频，2 图片，3 文档
   */
  type: number;
  /**
   * 类型名称
   */
  type_name: string;
  /**
   * 更新时间
   */
  updated_at: string;
  /**
   * 更新人
   */
  updated_by: string;
}

/**
 * 部门教程详情
 */
export interface IDeptTutorialDetail extends IDeptTutorial {
  /**
   * 文件列表，OSS 文件URL
   */
  attachments: IAttachment[];
  /**
   * 人员范围，unit 或 staff
   */
  scopes: IScope[];
  /**
   * 音色
   */
  timbres: ITimbreItem[];
}

export interface ITimbreItem {
  attachment: IAttachment;
  attachment_id: string;
  id: string;
  language: number;
  language_text: string;
  status: null;
  status_text?: null;
  timbre: null;
  timbre_text: null;
  tutorial_id: string;
}

export interface IScope {
  /**
   * 对象ID，unit_id 或 staff_id
   */
  id: string;
  /**
   * 对象名称，架构名称 或 员工名称
   */
  name: string;
  /**
   * 对象类型，unit 或 staff
   */
  type: string;
}

export interface IIPostedTutorialListRequest {
  /**
   * 搜索关键字
   */
  keyword?: string;
  /**
   * 页码
   */
  page?: number;
  /**
   * 分页大小
   */
  per_page?: number;
  /**
   * 教程状态，1 上架中，2 已下架
   */
  status?: string;
  /**
   * ea
   */
  ea?: number;
}

export interface ITutorialLearningHistoryRequest {
  /**
   * 排序方式，asc 顺序，desc 倒序
   */
  order?: string | undefined;
  /**
   * 页码
   */
  page?: number;
  /**
   * 分页大小
   */
  per_page?: number;
  /**
   * 我的学习记录
   * 排序字段
   * 教程名称   title
   * 课程编号   serial_number
   * 发布者       created_by
   * 观看时间   start_time
   *
   * 学员学习记录
   * 观看人姓名          user_name
   * 观看人所属组织   group_name
   * 观看状态              start_time
   * 观看时间              created_at
   */
  sort?: string | undefined;
}

export interface ITutorialLearningHistory {
  /**
   * 观看结束时间
   */
  end_time: string;
  /**
   * 记录ID
   */
  id: string;
  /**
   * 观看开始时间，观看时间
   */
  start_time: string;
  /**
   * 教程信息
   */
  tutorial: IDeptTutorial;
}

export type DeptTutorialsDetailResolveType = IResolve<IDeptTutorialDetail>;
export type DeptTutorialsResolveType = IPageResolve<IDeptTutorial[]>;
export type TutorialHistoryListType = IPageResolve<ITutorialLearningHistory[]>;

export interface ICreateTutorialRequest {
  /**
   * 文件列表，OSS 文件 path
   */
  attachments: string[];
  /**
   * 教程描述
   */
  description: string;
  /**
   * 结束时间
   */
  end_time: string;
  /**
   * 人员范围，架构（unit_id）或员工（staff_id）
   */
  scopes: string[];
  /**
   * 开始时间
   */
  start_time: string;
  /**
   * 教程标题
   */
  title: string;
  /**
   * 博客id
   */
  podcast_id?: string;
}
export type IEditTutorialRequest = ICreateTutorialRequest;

export interface ICreateTutorialResult {
  /**
   * 教程ID
   */
  id: string;
}

export type IEditTutorialResult = ICreateTutorialResult;

export interface IStructuresRequest {
  /**
   * 父ID
   * 1）为空时返回整个架构树；
   * 2）不为空时，返回下级架构或员工；
   * 3）初始可以传 '0'，返回一级架构（即：公司）
   */
  parent_id?: string;
  with_count: 0 | 1;
  with_staffs: 0 | 1;
}

export interface IStructures {
  /**
   * 下级部门
   */
  children?: IDepartment[];
  /**
   * 公司ID
   */
  key: string;
  /**
   * 父ID
   */
  parent_id: string;
  /**
   * 公司名称
   */
  title: string;
  /**
   * 类型，8 公司
   */
  type: number;
  /**
   * 人数
   */
  staffs_count?: number;
}

export interface IDepartment {
  /**
   * 下级组别
   */
  children?: ITeam[];
  /**
   * 部门ID
   */
  key: string;
  /**
   * 父ID，公司ID
   */
  parent_id: string;
  /**
   * 部门名称
   */
  title: string;
  /**
   * 对象类型，4 部门
   */
  type: number;
}

export interface ITeam {
  /**
   * 下级员工
   */
  children?: IStaff[];
  /**
   * 组别ID
   */
  key: string;
  /**
   * 父ID，部门ID
   */
  parent_id: string;
  /**
   * 组别名称
   */
  title: string;
  /**
   * 类型，2 组别
   */
  type: number;
}

export interface IStaff {
  /**
   * 公司名称
   */
  company_name?: null | string;
  /**
   * 部门名称
   */
  department_name?: null | string;
  /**
   * 组别名称
   */
  group_name?: null | string;
  /**
   * 员工ID
   */
  key: string;
  /**
   * 父ID，组别ID
   */
  parent_id: string;
  /**
   * 职位名称
   */
  position_name?: null | string;
  /**
   * 员工姓名
   */
  title: string;
  /**
   * 类型，0 员工
   */
  type: number;
}

/**
 * 教程学员学习记录
 */
export interface IStudentTutorialLearningHistory {
  /**
   * 公司名称
   */
  company_name: string;
  /**
   * 部门名称
   */
  department_name: string;
  /**
   * 观看时间-结束时间
   */
  end_time: null | string;
  /**
   * 组别名称
   */
  group_name: string;
  /**
   * 员工ID
   */
  id: string;
  /**
   * 职位名称
   */
  position_name: string;
  /**
   * 观看时间-开始时间
   */
  start_time: null | string;
  /**
   * 用户昵称
   */
  user_name?: null | string;
  /**
   * 观看状态，1 已观看，0 未观看
   */
  view_status: number;
}

export type StudentLearningHistoryType = IPageResolve<
  IStudentTutorialLearningHistory[]
>;

export interface IEALanguageInfo {
  /**
   * 区块哈希
   */
  block_hash: string;
  /**
   * 教程描述
   */
  description: string;
  /**
   * 文件时长，单位：秒
   */
  duration: number;
  /**
   * 教程ID
   */
  id: string;
  language: number;
  language_options: LanguageOption[];
  /**
   * 教程编号
   */
  serial_number: string;
  timbres: Timbre[];
  /**
   * 教程标题
   */
  title: string;
  /**
   * 教程类型，教程类型：1 视频，2 图片，3 文档
   */
  type: number;
}

export interface LanguageOption {
  label: string;
  value: number;
}

export interface Timbre {
  checked: boolean;
  voice_uuid?: string;
  language: number;
  language_text: string;
  status: number | null;
  timbre: number | null;
  timbre_options: TimbreOption[];
  timbre_text: null | string;
}
export interface TimbreOption {
  id: number;
  languageType: number;
  speed: number;
  timbre: number;
  timbreText: string;
  transpose: number;
  voiceId: number;
  voiceUuid: string;
}

export type EALanguagesInfoResolveType = IResolve<IEALanguageInfo>;

/**
 * 附件信息
 */
interface ITimbreAttachment {
  /**
   * 区块哈希
   */
  block_hash: string;
  /**
   * 转换后的文件路径
   */
  converted: string[];
  /**
   * 封面图片
   */
  cover: string;
  /**
   * 存储磁盘
   */
  disk: string;
  /**
   * 文件时长，单位：秒
   */
  duration: number;
  /**
   * 失败原因
   */
  failure_reason: string;
  /**
   * 文件哈希
   */
  file_hash: string;
  /**
   * 文件名称
   */
  filename: string;
  /**
   * 附件id
   */
  id: string;
  /**
   * 文件mime类型
   */
  mime_type: string;
  /**
   * 文件路径
   */
  path: string;
  /**
   * 状态：0 未处理，1 处理中，2 处理成功，3 处理失败
   */
  status: number;
  tutorial_id: string;
}

export interface ITimbre {
  /**
   * 附件信息
   */
  attachment?: ITimbreAttachment;
  /**
   * 附件id
   */
  attachment_id?: string;
  /**
   * 音色id
   */
  id: string;
  /**
   * 语种
   */
  language: number;
  /**
   * 语种名称
   */
  language_text: string;
  /**
   * 状态
   */
  status: number;
  /**
   * 状态名称
   */
  status_text: string;
  /**
   * 音色
   */
  timbre: number;
  /**
   * 语种
   */
  timbre_text: string;
  /**
   * 教程id
   */
  tutorial_id: string;
  /** 進度 */
  progress: number;
}

interface ITutorialTimbre {
  id: string;
  /**
   * 语言
   */
  language: number;
  language_text: string;
  /**
   * 教程名称
   */
  name: null;
  /**
   * 音色列表
   */
  timbres: ITimbre[];
}

export type TutorialTimbreResolveType = IResolve<ITutorialTimbre>;

/**
 * 检测语种
 */
export interface IDetectLanguage {
  language?: number;
  language_text: string;
}

/**
 * 创建部门教程EA视频请求体
 */
export interface ICreateTutorialEARequest {
  primitive_language: number;
  srt?: ISrt[];
  voice: IVoice;
  subtitles: number;
  bgm: number;
}
export interface IVoice {
  voice_uuid: string;
  voice_name: string;
  timbre: number;
  language: number;
  transpose: number;
  speed: number;
}

export interface ISrt {
  segmentId: number;
  segmentTime: string;
  segmentText: string;
  speed: number;
}
export enum TutorialTypeEnum {
  // 教程类型，教程类型：1 视频，2 图片，3 文档，4 音频，5 视频+音频
  Video = 1,
  Image = 2,
  Document = 3,
  Audio = 4,
}
export enum TutorialStatusEnum {
  // 教程状态：1 上架中，2 已下架
  Enable = 1,
  Forbidden = 2,
}
